import { FaTimes } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
const HelpPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <FaTimes className="text-xl" />
        </button>

        <p className="text-gray-800 text-md font-bold text-2xl ">Emergency help center</p>
        <p className="text-gray-800 ">Don't hesitate to contact us</p>
        <div className="mt-2 flex gap-[2px] items-center">
          <FiPhoneCall className="text-xl mr-2" />
          <span className="text-xl text-gray-800 ">
            + (994) 554706080</span>
        </div>

      </div>
    </div>
  );
};

export default HelpPopup;
